import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDesktop,
  faFileCode,
  faPencilRuler,
  faCamera,
  faPalette,
  faPaintBrush,
  faPencilAlt,
  faFileImage,
} from "@fortawesome/free-solid-svg-icons";

const Services = () => {
  return (
    <div id="services" className="services">
      <h1 className="py-5">My Services</h1>
      <div className="container">
        <div className="row">
          <div className="col">
            <div className="box">
              <div className="circle">
                <FontAwesomeIcon className="icon" icon={faDesktop} size="2x" />
              </div>
              <h2>Web Design</h2>
              <ul>
                <li>Trend Research</li>
                <li>Stock Photos</li>
                <li>Animation</li>
                <li>Responsive Design</li>
                <li>Accessibility</li>
              </ul>
            </div>
          </div>
          <div className="col">
            <div className="box">
              <div className="circle">
                <FontAwesomeIcon className="icon" icon={faFileCode} size="2x" />
              </div>
              <h2>Web Development</h2>
              <ul>
                <li>JavaScript</li>
                <li>React.js</li>
                <li>HTML</li>
                <li>CSS</li>
                <li>Deployment</li>
              </ul>
            </div>
          </div>
          <div className="col">
            <div className="box">
              <div className="circle">
                <FontAwesomeIcon
                  className="icon"
                  icon={faPencilRuler}
                  size="2x"
                />
              </div>
              <h2>Graphic Design</h2>
              <ul>
                <li>Logo Design</li>
                <li>Content Creation</li>
                <li>Layout Design</li>
                <li>Typography</li>
                <li>Color Theory</li>
              </ul>
            </div>
          </div>
          <div className="col">
            <div className="box">
              <div className="circle">
                <FontAwesomeIcon
                  className="icon"
                  icon={faPencilAlt}
                  size="2x"
                />
              </div>
              <h2>Illustration</h2>
              <ul>
                <li>Character Design</li>
                <li>Sketches</li>
                <li>Details</li>
                <li>Drawing</li>
                <li>Creativity</li>
              </ul>
            </div>
          </div>
          <div className="col">
            <div className="box">
              <div className="circle">
                <FontAwesomeIcon className="icon" icon={faCamera} size="2x" />
              </div>
              <h2>Photo Editing</h2>
              <ul>
                <li>Color Correction</li>
                <li>Lighting</li>
                <li>Angle Shots</li>
                <li>Removal of Imperfections</li>
                <li>Filters</li>
              </ul>
            </div>
          </div>
          <div className="col">
            <div className="box">
              <div className="circle">
                <FontAwesomeIcon className="icon" icon={faPalette} size="2x" />
              </div>
              <h2>Traditional Painting</h2>
              <ul>
                <li>Oil Paints</li>
                <li>Acrylic Paints</li>
                <li>Watercolor Paints</li>
                <li>Realism-Style</li>
                <li>Textures</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
